module.exports = __webpack_public_path__ + "img/product_1.0cef6890.png";